// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Wvvm","minimized":"styles_minimized__2mHYi"};